<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import Paginator from '../../components/paginator.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'

  let { point_sources: pointSources = [], pagy = { page: 1, pages: 1, count: 0 } } = $props()

  const toggleActive = (item, active) => {
    router.patch(`/point-sources/${item.id}/${active ? 'activate' : 'deactivate'}`, {}, { preserveScroll: true })
  }

  const archive = async (item) => {
    const confirmed = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    router.delete(`/point-sources/${item.id}`, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Point Sources" subtitle="Configure how members earn points" count={pagy.count}>
    {#snippet actions()}
      <Button href="/point-sources/new" variant="primary" size="sm" icon="add">New Point Source</Button>
    {/snippet}
  </PageHeader>

  <EntityList entity="point_source" rows={pointSources} onToggle={toggleActive} onDelete={archive} />

  <Paginator {...pagy} />
</Layout>
